<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.campaign" :label="labels.campaign" :error-messages="errors.collect('campaign')" data-vv-name="campaign" :data-vv-as="labels.campaign"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.description" :label="labels.description" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <cal-picker :label="labels.effDate" v-model="filters.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate"></cal-picker>
                      </v-flex>
                      <v-flex md6>
                        <cal-picker :label="labels.expDate" v-model="filters.expDate" :error-messages="errors.collect('expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate"></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-autocomplete :label="labels.campCommDisc" :items="campCommDiscTFList" v-model="filters.campCommDisc" item-text="value" item-value="code" data-vv-name="campCommDisc" :data-vv-as="labels.campCommDisc" :error-messages="errors.collect('campCommDisc')"></v-autocomplete>                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Campaign
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.campaign }}</td>
                <td>{{ row.item.description }}</td>
                <td>{{ formatDisplayDate(row.item.effDate) }}</td>
                <td>{{ formatDisplayDate(row.item.expDate) }}</td>
                <td>{{ row.item.campCommDisc ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.allIntermediary ? 'YES' : 'NO' }}</td>
                <td>{{ row.item.enabled ? 'YES' : 'NO' }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)" query @query="doQuery(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Campaign?
      </confirm>
    </div>
  </page>
</template>
<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Campaign Commission',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignCommList' }
        },
        {
          text: 'Campaign Discount',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignDiscList' }
        },
        {
          text: 'Campaign Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignPromotionList' }
        },
        {
          text: 'Permit Intermediary',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'campaignIntermediaryList' }
        },
        {
          text: 'Promotion',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'promotionList' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Campaign', value: 'campaign' },
        { text: 'Description', value: 'description' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'Campaign Comm.Disc', value: 'campCommDisc' },
        { text: 'All Intermediary', value: 'allIntermediary' },
        { text: 'Enabled', value: 'enabled' },
        TableConst.tableActionHeader
      ],
      labels: {
        campaign: 'Campaign',
        description: 'Description',
        effDate: 'Effective Date',
        expDate: 'Expiry Date ',
        campCommDisc: 'Campaign Commission/Discount'
      },
      filters: {
        campaign: undefined,
        description: undefined,
        effDate: undefined,
        expDate: undefined,
        campCommDisc: undefined,
        actionKey: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      campCommDiscTFList: [
        { code: true, value: 'Yes' },
        { code: false, value: 'No' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.expDate) {
            currFilters.expDate = formatDisplayDateTime2(removeTime(currFilters.expDate))
          }
          if (currFilters.effDate) {
            currFilters.effDate = formatDisplayDateTime2(removeTime(currFilters.effDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  campaign: datamap.campaign,
                  description: datamap.description,
                  effDate: datamap.effDate,
                  expDate: datamap.expDate,
                  campCommDisc: datamap.campCommDisc,
                  allIntermediary: datamap.allIntermediary,
                  enabled: datamap.enabled,
                  actionKey: datamap.actionKey
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.campaign = undefined
      this.filters.description = undefined
      this.filters.effDate = undefined
      this.filters.expDate = undefined
      this.filters.campCommDisc = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      this.$router.push({ name: 'campaignReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'campaignReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'campaignReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.doDelete
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.campaignParam.menu
    }
  },
  mounted() {
    this.filters.actionKey = 'CAMPAIGN'
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
